var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('panel',{attrs:{"title":"Tools"}},[_c('a',{staticClass:"btn btn-danger",on:{"click":function($event){$event.preventDefault();_vm.cleanSales()}}},[_vm._v("Clean all sales")])])}
var staticRenderFns = []

export { render, staticRenderFns }